module.exports = __webpack_public_path__ + "assets/img/summay.dc95c62d.png";